export default function thumbnailSlider() {
  return {
		restrict: 'A',
		link: function(scope, elem, attr){
			scope.scrollToRight = function(){
				elem[0].scrollLeft += Number(attr.thumbnailSlider);	
			};
			
			scope.scrollToLeft = function(){
				elem[0].scrollLeft -= Number(attr.thumbnailSlider);	
			};
			
		}
  };
}




// WEBPACK FOOTER //
// ./src/app/components/thumbnail-slider/directive.js